import { useNavigate } from 'react-router-dom';
import { Badge, IconButton, Tooltip } from '@mui/material';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';

import { routes } from '@carcareers/utils';
import { useChat } from '@carcareers/contexts';

export const ChatButton = () => {
  const navigate = useNavigate();
  const { hasUnread } = useChat();

  return (
    <Tooltip title="Messages">
      <IconButton onClick={() => navigate(routes.EMPLOYER_CHAT)}>
        <Badge
          invisible={!hasUnread}
          variant="dot"
          color="primary"
          sx={{
            '& .MuiBadge-badge': {
              right: 2,
              top: 3,
            },
          }}
        >
          <ChatBubbleIcon />
        </Badge>
      </IconButton>
    </Tooltip>
  );
};
